<template>
    <div class="block-bid-past-member">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price">
                    <div class="current-price border-color-red">
                        <div class="top">
                            <div class="text-price-now font-weight-bold">
                                最高入札価格
                            </div>
                            <div class="price color-red">
                                <span class="number">¥</span>
                                <span class="number">{{
                                        formatPrice(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">¥ {{
                                        handlePriceTaxAndServiceFee(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-enter-bid">
                    <div class="left">あなたの入札価格</div>
                </div>
                <div class="block-notification-price">
                    <div class="current-price border-color-grey">
                        <div class="top">
                            <div class="price" :class="(bidTop && bidTop.member_id == member.id) ? '' : 'price-line-through'">
                                <span class="number">¥</span>
                                <span class="number">{{
                                        formatPrice(pricePlaced)
                                    }}</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">¥ {{
                                        handlePriceTaxAndServiceFee(pricePlaced)
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="bidTop && bidTop.member_id == member.id" class="text-won-bid mt-3 d-flex fs-20 font-weight-bold">落札</div>
                    <div v-else class="text-not-win-bid mt-3 d-flex fs-20 font-weight-bold">他のお客様が落札しました</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {COMMON} from "./../../common";

export default {
    mounted() {

    },
    async created() {
        this.serviceFee = this.taxConfig.service_fee;
        this.tax = this.taxConfig.tax;
        this.pricePlaced = this.myBidTop ? this.formatPrice(this.myBidTop.amount) : 0;
    },
    props: [
        'product',
        'auction',
        'member',
        'bidTop',
        'myBidTop',
        'taxConfig'
    ],
    data: function () {
        return {
            serviceFee: 0,
            tax: 0,
            pricePlaced: 0,
        }
    },
    methods: {
        formatPrice(price) {
            return COMMON.handleFormatPrice(price);
        },

        handlePriceTaxAndServiceFee(pricePresent) {
            this.partIntPricePlaced();
            let price = COMMON.handlePriceTaxAndServiceFee(pricePresent, this.serviceFee, this.tax);

            return this.formatPrice(price);
        },

        partIntPricePlaced () {
            if (this.pricePlaced && typeof this.pricePlaced === 'string') {
                this.pricePlaced = parseInt(this.pricePlaced.replace(/[^0-9]/g, ''))
            }
        },
    },
    computed: {

    },
}
</script>
